import React, { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';

/**
 * Root page with reliable navigation
 */
const RootPage: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  console.log('RootPage rendering:', { isAuthenticated, isLoading, user: !!user });

  // Use useEffect for navigation instead of Navigate component
  useEffect(() => {
    if (!isLoading) {
      console.log('RootPage: Not loading, checking auth status');
      if (isAuthenticated && user) {
        // All users go to Match Betting as the default first tab
        console.log('RootPage: Authenticated, navigating to match betting');
        navigate(ROUTE_PATHS.MATCHES, { replace: true });
      } else {
        console.log('RootPage: User not authenticated, navigating to login');
        navigate(ROUTE_PATHS.LOGIN, { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, user, navigate]);

  // Show loading state while checking auth or navigating
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '40px', 
        borderRadius: '12px',
        textAlign: 'center',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px'
      }}>
        <div style={{ marginBottom: '20px' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #e3e3e3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>

        <h2 style={{ color: '#333', marginBottom: '15px' }}>
          ProjectViva
        </h2>
        
        {isLoading ? (
          <p style={{ color: '#666' }}>Checking authentication...</p>
        ) : isAuthenticated ? (
          <p style={{ color: '#27ae60' }}>✅ Authenticated - Redirecting to match betting...</p>
        ) : (
          <p style={{ color: '#e74c3c' }}>❌ Not authenticated - Redirecting to login...</p>
        )}

        <div style={{ 
          marginTop: '20px',
          fontSize: '12px',
          color: '#999'
        }}>
          <p>Debug: Loading={isLoading ? 'true' : 'false'}, Auth={isAuthenticated ? 'true' : 'false'}</p>
        </div>
      </div>
    </div>
  );
};

export default RootPage;